import { PRODUCTS_FIELD } from './constants';

declare global {
  interface Window {
    FreshworksWidget?: FreshworksWidgetFn;
    fwSettings?: {
      widget_id: string;
    };
  }

  type FreshworksWidgetFn = {
    (...args: any[]): void;
    q?: any[];
  };
}

export const openSupportForm = (
  userEmail: string | null,
  product: keyof typeof PRODUCTS_FIELD,
  prefill?: Record<string, string>,
) => {
  if (product === 'posts' || product === 'onboarding') {
    selfServeSetup(userEmail, product, prefill);
  } else {
    basicSetup(userEmail, product);
  }
  window.FreshworksWidget?.('open');
};

const basicSetup = (email: string | null, product: keyof typeof PRODUCTS_FIELD) => {
  window.FreshworksWidget?.('destroy');
  window.FreshworksWidget?.('boot');
  window.FreshworksWidget?.('hide', 'launcher');
  window.FreshworksWidget?.('identify', 'ticketForm', {
    email: email || '',
    custom_fields: {
      cf_product: PRODUCTS_FIELD[product],
    },
  });
};

const selfServeSetup = (
  email: string | null,
  product: 'posts' | 'onboarding',
  prefill?: Record<string, string>,
) => {
  window.FreshworksWidget?.('hide', 'launcher');
  window.FreshworksWidget?.('destroy');
  window.FreshworksWidget?.('boot');
  window.FreshworksWidget?.('hide', 'launcher');
  window.FreshworksWidget?.('identify', 'ticketForm', {
    email: email || '',
    custom_fields: {
      cf_product: PRODUCTS_FIELD[product],
    },
  });
  window.FreshworksWidget?.('hide', 'ticketForm', ['name']);

  const match = window.location.pathname.match(/\/property\/([0-9a-fA-F-]{36})/);
  const propertyId = match?.[1];

  if (propertyId) {
    window.FreshworksWidget?.('prefill', 'ticketForm', {
      custom_fields: {
        cf_partner_name: prefill?.partnerName,
        cf_property_name: prefill?.propertyName,
        cf_fiona_posts_property_id: prefill?.propertyId,
      },
    });
  }
};
